export function initNavigation($) {
  // Mobile Menu Dropdown
  var carrot =
    '<span class="carrot"><svg width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 0.5L6.9 6.5L13.3 0.5" stroke="#031C34" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
  
  $(".mobile-nav .menu-item-has-children > a").each(function () {
    // prevent duplicate carrots
    if (!$(this).find(".carrot").length) {
      $(this).append(carrot);
    }
  });
  
  $(".mobile-nav").on("click", ".carrot", function (event) {
    event.preventDefault();
    event.stopPropagation();
  
    var $menuItem = $(this).closest(".menu-item-has-children");
  
    $menuItem.toggleClass("clicked");
    $menuItem.children(".megamenu").toggleClass("active");
  });
  
  $(".menu-toggle").on("click", function (e) {
    e.preventDefault();
    $(this).toggleClass("clicked");
    $(".mobile-nav-container").toggleClass("active");
  });
  
  // Blog Category Selector
  $(".blog-cat-switcher").change(function (event) {
    var category = $(".blog-cat-switcher option:selected").val();
    window.location.href = category;
  });
  
  //add header scroll class, for header sticky
  function headerScroll() {
    var target = $("header");
  
    if (target.length > 0) {
      if ($("body").hasClass("home")) {
        // On homepage: toggle on scroll
        $(window).on("scroll", function () {
          if ($(this).scrollTop() > 0) {
            target.addClass("scrolled");
          } else {
            target.removeClass("scrolled");
          }
        });
  
        // Also run on page load to set initial state
        if ($(window).scrollTop() > 0) {
          target.addClass("scrolled");
        }
      } else {
        // All non-home pages (including single posts)
        $(window).on("scroll", function () {
          if ($(this).scrollTop() > 0) {
            target.addClass("scrolled");
          } else {
            target.removeClass("scrolled");
          }
        });
  
        // Also run on page load to set initial state
        if ($(window).scrollTop() > 0) {
          target.addClass("scrolled");
        }
      }
    }
  }
  
  headerScroll();
}
